<template>
    <Modal
        :opened="openedInternal"
        :dissmisable="!loading"
        @close="handleClose"
    >
        <template #header>
            <fragment v-if="!hideClose" />
            <slot name="header" />
        </template>

        <template #body>
            <div class="Content">
                <slot>
                    <div class="Wrapper">
                        <WIcon
                            v-if="icon"
                            :icon="icon"
                            :color="iconColor"
                            :size="iconSize"
                        />
                        <WText
                            weight="bold"
                            size="24"
                            align="center"
                            class="Title"
                        >
                            {{ title }}
                        </WText>

                        <slot name="content" />

                        <div class="ButtonsWrapper">
                            <WButton
                                v-if="cancelText"
                                :color="cancelColor"
                                :disabled="loading"
                                linkColor="secondary"
                                class="Cancel"
                                @click="handleClose"
                            >
                                {{ cancelText }}
                            </WButton>
                            <WButton
                                v-if="okText"
                                :color="okColor"
                                :loading="loading"
                                :disabled="loading"
                                @click="handleAccept"
                            >
                                {{ okText }}
                            </WButton>
                        </div>
                    </div>
                </slot>
            </div>
        </template>
    </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import Modal from '../Modal/Modal.vue'

export default {
    name: 'ModalRequest',
    components: { Modal },
    props: {
        opened: VueTypes.bool.def(false),
        loading: VueTypes.bool.def(false),
        title: VueTypes.string,
        cancelText: VueTypes.string,
        cancelColor: VueTypes.string.def('link'),
        okText: VueTypes.string,
        okColor: VueTypes.string.def('primary'),
        icon: VueTypes.string,
        iconColor: VueTypes.string.def(''),
        iconSize: VueTypes.number.def(48),
        hideClose: VueTypes.bool.def(false),
        preventDefault: VueTypes.bool.def(false),
    },
    data () {
        return {
            openedInternal: false,
        }
    },
    watch: {
        opened (value) {
            this.openedInternal = value
        },
    },
    created () {
        // Se supone que esto solo debe funcionar cuando se crea el componente pero por alguna razón lo hace desde el principio.
        window.addEventListener('keypress', this.onKeyPress)
    },
    destroyed () {
        // Esto es para limpiar la escucha pero nunca se destruye.
        window.removeEventListener('keypress', this.onKeyPress)
    },
    methods: {
        open () {
            this.openedInternal = true
        },
        close () {
            this.openedInternal = false
        },
        handleClose () {
            this.$emit('close')
            this.openedInternal = false
        },
        handleAccept () {
            if (!this.preventDefault) this.openedInternal = false
            setTimeout(() => this.$emit('onAccept'), 450)
        },
        /**
         * Cuando se presiona el "enter" debe realizar la acción del "Aceptar".
         * @param {KeyboardEvent} e Evento de teclado.
         */
        onKeyPress (e) {
            if (this.opened && e.key === 'Enter') {
                e.preventDefault()
                // Si está abierto y se presiona enter.
                this.handleAccept()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.Wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
    margin: 0 45px 30px 45px;

	.WIcon {
		margin-bottom: 15px;
	}
	.Title {
		margin-top: 15px;
		margin-bottom: 45px;
	}
	.Cancel {
		margin-right: 45px;
	}
	.ButtonsWrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
</style>
